import { render, staticRenderFns } from "./BettingActions.vue?vue&type=template&id=6d4003c4&"
import script from "./BettingActions.vue?vue&type=script&lang=js&"
export * from "./BettingActions.vue?vue&type=script&lang=js&"
import style0 from "./BettingActions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports